export default __webpack_public_path__ + "static/media/Freebooter's Treads of the Painted Claw.1180e53d.jpg";